<template>
    <div>
        <b-row>
        </b-row>
        <b-row>
            <b-col cols="9" class="text-left">
                <div style="float: left">
                    <b-button v-b-toggle="`collapse-core`" size="sm"
                              class="bg-transparent chev-btn">
                                <span class="when-opened">
                                    <i class="fa fa-chevron-down fa-2x" aria-hidden="true" style="color: #1b1e21;"></i>
                                </span>
                        <span class="when-closed">
                                    <i class="fa fa-chevron-up fa-2x" aria-hidden="true" style="color: #1b1e21;"></i>
                                </span>
                    </b-button>
                </div>
                <h2>
                    <span style="color: green">Core Questions</span>
                </h2>
            </b-col>
            <b-col cols="3">
            </b-col>
        </b-row>
        <b-collapse style="margin-left: 30px; width: 90%" id="collapse-core">
            <b-row>
                <b-col cols="4">
                    <h4> Measure Type: CORE</h4>
                </b-col>
                <b-col cols="8" class="text-right">
                    <div style="float: right; padding-top: 5px; padding-right: 5px; vertical-align: top;">
                        <span class="add-measure">Add Measure</span>
                        <font-awesome-icon icon="plus-circle" size="2x"
                                           @click="showCreateMeasureModal(pageName, 'CORE')"/>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <draggable
                        @start="drag=true" :list="coreQuestions"
                        style="background-color: #95999c; width: 100%; margin-bottom: 5px"
                        @end="onEnd" handle=".handle">
                    <DraggableQuestion v-for="coreQuestion in coreQuestions"
                                       section="section" :element="coreQuestion"
                                       :key="coreQuestion._id" :pageName="pageName"/>
                </draggable>
            </b-row>
        </b-collapse>
        <b-row>
            <b-col cols="9" class="text-left">
                <div style="float: left">
                    <b-button v-b-toggle="`collapse-elective`" size="sm"
                              class="bg-transparent chev-btn">
                                <span class="when-opened">
                                    <i class="fa fa-chevron-down fa-2x" aria-hidden="true" style="color: #1b1e21;"></i>
                                </span>
                        <span class="when-closed">
                                    <i class="fa fa-chevron-up fa-2x" aria-hidden="true" style="color: #1b1e21;"></i>
                                </span>
                    </b-button>
                </div>
                <h2>
                    <span style="color: orange">Elective Questions</span>
                </h2>
            </b-col>
            <b-col cols="3">
            </b-col>
        </b-row>
        <b-collapse style="margin-left: 30px; width: 90%" id="collapse-elective">
            <b-row>
                <b-col cols="4">
                    <h4>Measure Type: ELECTIVE</h4>
                </b-col>
                <b-col cols="4">
                    <h4>Required Electives: {{ requiredElectives }}</h4>
                </b-col>
                <b-col cols="4" class="text-right">
                    <div style="float: right; padding-top: 5px; padding-right: 5px; vertical-align: top;">
                        <span class="add-measure">Add Measure</span>
                        <font-awesome-icon icon="plus-circle" size="2x"
                                           @click="showCreateMeasureModal(pageName, 'ELECTIVE')"/>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <draggable @start="drag=true" :list="electiveQuestions"
                           style="background-color: #95999c; width: 100%; margin-bottom: 5px"
                           @end="onEnd" :move="checkMove" handle=".handle">

                    <DraggableQuestion v-for="electiveQuestion in electiveQuestions"
                                       :key="electiveQuestion._id"
                                       section="section" :element="electiveQuestion" :pageName="pageName"/>
                </draggable>
                <b-modal :id="`modal-${pageName}`" class="modal" :ref="`modal-${pageName}`"
                         size="xl"
                         title="Measure Creator" effect="fade/zoom" @close="cancel(id)">
                    <b-row>
                        <b-col cols="1">
                        </b-col>
                        <b-col cols="10">
                            <div>
                                <b-row>
                                    <b-col cols="2">Title:</b-col>
                                    <b-col cols="4">
                                        <b-form-input :id="`question-name${ newMeasure }`" v-model="newMeasure.name"
                                                      :disabled=true></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="2">
                                        <label>Measure Category:</label>
                                    </b-col>
                                    <b-col cols="10">
                                        <b-form-select id="question-category" v-model="newMeasure.type"
                                                       :options="questionRequireOptions" :disabled=true></b-form-select>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="2">
                                        <label :for="`question-type${ newMeasure }`">Measure Type:</label>
                                    </b-col>
                                    <b-col cols="10">
                                        <b-form-select :id="`question-type${ newMeasure }`"
                                                       v-model="newMeasure.controlType"
                                                       :options="questionTypeOptions" :disabled=false></b-form-select>
                                    </b-col>
                                </b-row>
                                <b-row style="margin: 5px 0 0 0" v-if="isCheckbox">
                                    <b-col cols="2">
                                        <label :for="`choices${ newMeasure._id }`">Checkable Options:</label>
                                    </b-col>
                                    <b-col cols="2">
                                        <font-awesome-icon icon="plus-circle" size="1x"
                                                           @click="addOption(newMeasure._id)"/>
                                        Add Option
                                    </b-col>
                                    <b-col cols="8">
                                        <b-row style="margin: 5px 0 0 0; vertical-align: center"
                                               v-for="(option) in theChoices"
                                               :key="option.id">
                                            <input style="width: 90%; margin-right: 2px"
                                                   v-model="option.value"
                                                   :key="option.id"
                                                   :disabled=false></input>
                                            <font-awesome-icon
                                                    style="line-height: inherit; margin-left: 2px; margin-top: 3px"
                                                    icon="minus-circle" size="1x"
                                                    @click="deleteOption(option)"/>
                                        </b-row>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="2">
                                        <label :for="`question-text${ newMeasure }`">Question Text:</label>
                                    </b-col>
                                    <b-col cols="10">
                                        <b-form-textarea rows="3" max-rows="6" :id="`question-text${ newMeasure }`"
                                                         v-model="newMeasure.title">
                                        </b-form-textarea>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="2">
                                        <label :for="`question-text${ newMeasure }`">Green Note:</label>
                                    </b-col>
                                    <b-col cols="10">
                                        <b-form-textarea rows="3" max-rows="6" :id="`question-text${ newMeasure }`"
                                                         v-model="newMeasure.greenNote">
                                        </b-form-textarea>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="2"><label :for="`question-qnum-new`">Question Number</label>
                                    </b-col>
                                    <b-col cols="10">
                                        <b-form-input :id="`question-qnum-new`" v-model="newMeasure.qnum"
                                                      :disabled=true>{{ newMeasure.qnum }}
                                        </b-form-input>
                                    </b-col>
                                </b-row>
                            </div>
                        </b-col>
                        <b-col cols="1">
                        </b-col>
                    </b-row>
                    <div slot="modal-footer" class="modal-footer">
                        <button type="submit" class="btn btn-success" @click="createMeasure(newMeasure.type,pageName)">
                            Create
                        </button>
                        <button type="button" class="btn btn-default" @click="cancel(pageName)">Cancel</button>
                    </div>
                </b-modal>
            </b-row>
        </b-collapse>
    </div>
</template>
<script>
import Draggable from 'vuedraggable';
import DraggableQuestion from "./DraggableQuestion";
import {v4 as uuidv4} from 'uuid';
import Bus from "../eventBus";

export default {
  name: 'CheckListPage',
  components: {
    Draggable,
    DraggableQuestion
  },
  props: {
    page: {}
  },
  data() {
    return {
                id: this.page._id,
                pageName: this.page.pageName,
                pageNumber: this.page.pageNumber,
                coreQuestions: this.page.coreQuestions,
                electiveQuestions: this.page.electiveQuestions,
                requiredElectives: this.page.requiredElectives,
                newMeasure: {
                    _id: null,
                    title: 'title',
                    name: "name",
                    type: "",
                    qnum: 0,
                    choices: [],
                    controlType: 'MATRIX',
                    colCount: 1
                },
                questionRequireOptions: [
                    {value: "CORE", text: "CORE"},
                    {value: "ELECTIVE", text: "ELECTIVE"}
                ],
                questionTypeOptions: [
                    {value: "CHECKBOX", text: "CHECKBOX"},
                    {value: "COMMENT", text: "COMMENT"},
                    {value: "MATRIX", text: "MATRIX"},
                    {value: "TEXT", text: "TEXT"}
                ],
                theChoices: []
            }
        },
        mounted() {
            this.newMeasure.choices.forEach((value, i) => {
                this.theChoices.push({id: i, value: value});
            })
            if (this.newMeasure.controlType === "CHECKBOX") {
                console.log("Choices");
                console.log(this.measure.choices);
                console.log(this.theChoices)
            }

        },
        computed: {
            isCheckbox: function () {
                return this.newMeasure.controlType === 'CHECKBOX';
            },
        },
        methods: {
            addOption: function (id) {
                this.theChoices.push({id: this.theChoices.length, value: 'New Option'});
            },
            deleteOption: function (option) {
                let index = this.newMeasure.choices.indexOf(option);
                this.newMeasure.choices.splice(index, 1);
            },
            onEnd: function (evt) {
                let self = this;
                this.coreQuestions.forEach(quest => {
                    quest.qnum = self.coreQuestions.indexOf(quest) + 1;
                });

                this.electiveQuestions.forEach(this.updateQuestionNumbers);
                Bus.$emit("update-survey");
                return false;
            },
            updateQuestionNumbers: function (quest) {
                let questIndex = this.electiveQuestions.indexOf(quest);
                if (quest.controlType === "COMMENT") {
                    quest.qnum = 0;
                } else {
                    quest.qnum = questIndex + 1;
                }
            },
            logDraggable: function (question, newIndex, evt) {
                if (this.$route.query.debug === true) {
                    console.log(`Question:`);
                    console.log(question);
                    console.log(`New Index: ${newIndex}`);
                    console.log(`List Length: ${evt.relatedContext.list.length}`);
                    console.log(`Control Type: ${question.controlType}`);
                }
            },
            checkMove: function (evt) {
                let newIndex = evt.draggedContext.futureIndex;
                let canMove;
                let question = evt.draggedContext.element;
                let listLength = evt.relatedContext.list.length;
                let normalizedListLength = listLength - 1;
                if (question.controlType !== "COMMENT" && (newIndex >= normalizedListLength)) {
                    canMove = false;
                } else {
                    canMove = !(question.controlType === "COMMENT" && (newIndex <= normalizedListLength));
                }
                return canMove;
            },
            showCreateMeasureModal: function (id, type) {
                let newQuestionNumber = type === "CORE" ? this.coreQuestions.length + 1 : this.electiveQuestions.length;
                this.newMeasure.type = type;
                this.newMeasure.controlType = "MATRIX";
                this.newMeasure.qnum = newQuestionNumber;
                this.newMeasure.name = uuidv4();
                this.$bvModal.show(`modal-${id}`);

                let question = this.getNewQuestion(newQuestionNumber, type)
            },
            getNewQuestion: function (questionNumber, type) {
                return {
                    id: null,
                    name: uuidv4(),
                    text: 'New Question Test',
                    type: type,
                    creatorId: '',
                    creationDate: Date.now(),
                    controlType: "MATRIX",
                    columns: ["Yes", "No", "N/A"],
                    qnum: questionNumber,
                    hasNone: false,
                    colCount: 1,
                    choices: [],
                    title: 'New Question Test',
                    greenNote: ''
                };
            },
            copyMeasure: function (measureToCopy) {
                return {
                    _id: measureToCopy._id,
                    name: measureToCopy.name,
                    text: measureToCopy.text,
                    type: measureToCopy.type,
                    creatorId: measureToCopy.creatorId,
                    creationDate: measureToCopy.creationDate,
                    controlType: measureToCopy.controlType,
                    columns: measureToCopy.columns,
                    qnum: measureToCopy.qnum,
                    hasNone: measureToCopy.hasNone,
                    colCount: measureToCopy.colCount,
                    choices: measureToCopy.choices,
                    title: measureToCopy.title,
                    greenNote: measureToCopy.greenNote
                };
            },
            createMeasure: function (measureType, id) {
                this.$bvModal.hide(`modal-${id}`);
                let measureToAdd = this.copyMeasure(this.newMeasure);
                if (measureType === 'CORE') {
                    this.coreQuestions.push(measureToAdd);
                } else {
                    this.electiveQuestions.splice(this.electiveQuestions.length - 1, 0, measureToAdd);
                }
                let self = this;
                this.theChoices.forEach(val => {
                    let theIndex = self.theChoices.indexOf(val);
                    if (theIndex <= (measureToAdd.choices.length - 1)) {
                        this.$set(measureToAdd.choices, theIndex, val.value);
                    } else {
                        measureToAdd.choices.push(val.value);
                    }
                });
                Bus.$emit("create-measure", measureToAdd, this.pageName);
            },
            cancel: function (id) {
                this.$bvModal.hide(`modal-${id}`);
                if (this.$route.query.debug === true) {
                    console.log(`Page Id ${id}`);
                    console.log(this.newMeasure);
                }
            },
            removeQuestion: function (id, type, pageName, measureName) {
                let self = this;
                if (this.pageName === pageName) {
                    if (type === "CORE") {
                        this.coreQuestions.forEach(quest => {
                            if (quest._id === id && quest.name === measureName) {
                                let index = self.coreQuestions.map(function (e) {
                                    return e.name;
                                }).indexOf(measureName);
                                self.coreQuestions.splice(index, 1);
                            }
                        });
                        this.coreQuestions.forEach(quest => {
                            quest.qnum = self.coreQuestions.indexOf(quest) + 1;
                        });
                    } else {
                        this.electiveQuestions.forEach(quest => {
                            if (quest._id === id && quest.controlType !== "COMMENT" && quest.name === measureName) {
                                let index = self.electiveQuestions.map(function (e) {
                                    return e.name;
                                }).indexOf(measureName);
                                self.electiveQuestions.splice(index, 1);
                            }
                        });
                        this.electiveQuestions.forEach(this.updateQuestionNumbers);
                    }
                }
            },
            deleteMeasure: function (id, type, pageName, measureName) {
                if (pageName === this.pageName) {
                    this.removeQuestion(id, type, pageName, measureName)
                    Bus.$emit("update-survey");
                }
            }
        },
        created() {
            Bus.$on('delete-measure', this.deleteMeasure);
        },
        beforeDestroy() {
            Bus.$off('delete-measure', this.deleteMeasure);
        }
    }
</script>
<style scoped>
    .add-measure {
        text-transform: capitalize;
        font-size: 24px;
        padding-right: 10px;
    }

</style>
